<div id="main-wrapper">
    <% if ( user )  {   %>

        <main-navigation></main-navigation>
        <div class="page-wrapper">
            <div class="body-wrapper">
                <div class="container-fluid mw-100">
                    <header class="topbar sticky-top">
                        <div class="with-vertical">
                            <header-bar></header-bar>
                        </div>
                    </header>
                    <div class="mb-3 overflow-hidden position-relative">
                        <content-header></content-header>
                    </div>
                    <section data-id="page-content" class="page-content"></section>
                </div>
            </div>
        </div>

    <% } else { %>

        ### NOT LOGGED IN ###

    <% }    %>
</div>
